import 'debug';
import { E as EventHub, q as _defineProperty, _ as _asyncToGenerator, h as _regeneratorRuntime } from './index2.js';
import 'deepmerge';
import 'axios';
import Vue from 'vue';

var App = Vue.extend({
  methods: {
    onBackKeyDown: function onBackKeyDown(e) {
      this.$xp.history.back();
    },
    onActivityPause: function onActivityPause() {
      EventHub.Bus.$emit(EventHub.TYPES.ANDROID_ACTIVITY_PAUSE);
    },
    init: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('----------', this.$xp);
                document.addEventListener('pause', this.onActivityPause, false);
                document.addEventListener('backbutton', this.onBackKeyDown, false);
                this.$xp.battery.init();
                this.$xp.network.startListening();
                this.$xp.screen.setBrightness();

                if (this.$xp.device.platform === 'ios') {
                  window.StatusBar.hide();
                  window.addEventListener('statusTap', function () {
                    window.StatusBar.isVisible ? window.StatusBar.hide() : console.log('it should be visible but its not');
                  }, false);
                }

                _context.prev = 7;
                _context.next = 10;
                return this.$xp.device.checkPermissions();

              case 10:
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](7);
                console.log('checkPermission error');
                console.warn(_context.t0);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 12]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }(),
    initNfc: function initNfc() {
      this.$watch('$xp.settings.mergedSettings.radio.nfcActive', {
        immediate: true,
        handler: function handler(value) {
          if (this.$xp.device.platform !== 'browser') {
            if (value !== this.$xp.nfc.isEnabled) {
              if (value) {
                this.$xp.nfc.enable();
              } else {
                this.$xp.nfc.disable();
              }
            }
          }
        }
      });
    },
    initEva: function () {
      var _initEva = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$xp.device.getUuid();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initEva() {
        return _initEva.apply(this, arguments);
      }

      return initEva;
    }()
  },
  created: function created() {
    this.init();
    this.$xp.nfcInstalled && this.initNfc();

    if (this.$xp.device.isLoan) {
      var shouldRestoreHistory = window.localStorage.getItem('shouldRestoreHistory');

      if (shouldRestoreHistory === 'true') {
        console.log('restoring history from local storage');
        this.$xp.history.restoreHistoryState();
        window.localStorage.setItem('shouldRestoreHistory', false);
        this.$xp.history.back();
      }
    }

    this.$xp.evaInstalled && this.initEva();
  },
  watch: {
    '$xp.settings.mergedSettings.isWifiRequired': {
      handler: function handler(newVal) {
        console.log('isWifiRequired changed: ' + newVal);

        if (this.$xp.device.platform === 'android') {
          if (newVal) {
            this.$xp.wifi.lockWifiConnectionOn('page');
          } else {
            this.$xp.wifi.releaseWifiConnectionOn('page');
          }
        }
      }
    },
    '$xp.settings.mergedSettings.screen.brightness': {
      handler: function handler(newValue) {
        this.$xp.screen.setBrightness(newValue);
      }
    },
    '$xp.settings.mergedSettings.theme': {
      immediate: true,
      handler: function handler(newVal) {
        document.querySelector('html').className = newVal;
      }
    },
    '$xp.media.isMediaPlaying': {
      handler: function handler(value) {
        if (!this.$xp.device.isLoan && this.$xp.device.platform !== 'browser') {
          if (value) {
            // keepAwake
            window.plugins.insomnia.keepAwake(function () {
              console.log('keepAwake success');
            }, function (error) {
              console.log('keepAwake ERROR', error);
            });
          } else {
            // allowSleepAgain
            window.plugins.insomnia.allowSleepAgain(function () {
              console.log('allowSleepAgain success');
            }, function (error) {
              console.log('allowSleepAgain ERROR', error);
            });
          }
        }
      }
    }
  },
  render: function render(h) {
    var _class;

    // <div id="app" :class="{
    // 'c-app': true,
    // 'c-app--rtl': $xp.polyglot.rtl,
    // 'c-app--is-loan': $xp.device.isLoan,
    // [`c-app--${$xp.device.platform}`]: true,
    // 'c-app--safari': $xp.device.isIPhoneOrPad,
    // [`c-app--${$xp.screen.orientation}`]: true,
    // 'c-app__ios-safari-navbar': $xp.device.platform === 'browser' && $xp.device.isIPhoneOrPad && $xp.screen.isBrowserNavBarVisible
    // }">
    //   <router-view></router-view>
    //   <div v-if="this.$xp.navigation.isEventConsumerEnabled" class="c-app__event-consumer"></div>
    //   <network-error-screen v-if="!$xp.network.isOnline && !$xp.device.isLoan"></network-error-screen>
    // </div>
    return h('div', {
      class: (_class = {
        'c-app': true,
        'c-app--rtl': this.$xp.polyglot.rtl,
        'c-app--is-loan': this.$xp.device.isLoan
      }, _defineProperty(_class, "c-app--".concat(this.$xp.device.platform), true), _defineProperty(_class, 'c-app--safari', this.$xp.device.isIPhoneOrPad), _defineProperty(_class, "c-app--".concat(this.$xp.screen.orientation), true), _defineProperty(_class, 'c-app__ios-safari-navbar', this.$xp.device.platform === 'browser' && this.$xp.device.isIPhoneOrPad && this.$xp.screen.isBrowserNavBarVisible), _class)
    }, [h('router-view'), this.$xp.navigation.isEventConsumerEnabled || this.$xp.http.isLoading ? h('div', {
      class: 'c-app__event-consumer'
    }) : null, !this.$xp.network.isOnline && !this.$xp.device.isLoan ? h('network-error-screen') : null]);
  }
});

export default App;
